// Single source of truth for the "is this gallery entry a video" domain rule. A product image is
// `{ key, type }` where type is 'image' | 'video' (see packages/data productTransformer). Change
// video detection (new type values, a mimeType field, …) here and every caller follows.
const isVideoImage = (image) => image?.type === 'video';

export default isVideoImage;
